import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {SquareArrowUpRightIcon} from 'shells/icon/svg/square-arrow-up-right-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import styles from './footer.module.css';

export const Footer = () => {
    return (
        <a
            href='/wallboard'
            target='_blank'
            rel='noreferrer noopener'
            className={styles['wallboard-link']}
        >
            <StackLegacy isHorizontal={true} alignCenter={true} spacing={12}>
                <Body size='small' color='white'>
                    Launch wallboard
                </Body>
                {/* @ts-expect-error */}
                <SquareArrowUpRightIcon size={14} alignCenter={true} color={colors.white} />
            </StackLegacy>
        </a>
    );
};
